module.exports = __webpack_public_path__ + "static/media/currency_rupee.2fee6393.svg";